<div class="header-container-left">
  <span class="header-title">{{config?.title}}</span>
</div>

<div class="header-container-right">
  <button *ngIf="config?.canMaximize" mat-icon-button (click)="maximize()">
    <mat-icon>{{isMaximized ? 'close_fullscreen' : 'open_in_full'}}</mat-icon>
  </button>
  <button *ngIf="config?.canOpenInNewWindow" mat-icon-button (click)="openInNew()">
    <mat-icon>open_in_new</mat-icon>
  </button>
  <button *ngIf="config?.canCloseWindow" mat-icon-button (click)="close($event)">
    <mat-icon>close</mat-icon>
  </button>
</div>
